<template>
  <div class="enhancements-time container">
    <div
      v-if="!haveIcon"
      class="enhancements-image"
    >
      <picture
        v-lazyload="{
          src: enhancement.icon,
          set: [
            { width: '480', height: '240', breakpoint: 'xs' },
            { width: '800', height: '360', breakpoint: 'md' }
          ],
          fit: 'crop',
          align: 'center'
        }"
        class="image-wrapper"
      >
        <img
          class="image"
          src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
          :alt="enhancement.name"
        >
      </picture>
    </div>
    <div class="enhancements-content-header">
      {{ enhancement.name }}
    </div>
    <div class="enhancements-content-description">
      {{ enhancement.description }}
    </div>
    <div
      id="preferred-time-group"
      class="enhancements-content-subheader"
    >
      {{ tc('enhancements.chooseTime') }}
    </div>
    <selectable-group
      v-model="selectedTime"
      label-id="preferred-time-group"
      :options="options"
      :show-icon="true"
    />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import SelectableGroup from '@components/01.base/01.forms/selectable-group/selectable-group.vue'
  import { ENHANCEMENT_USER_INPUTS } from '@utils/constants'
  import preferredTime from '../../../../../../../store/cart/enhancements/preferred-time'

  export default {
    name: 'PreferredTime',
    components: { SelectableGroup },
    props: {
      enhancement: {
        type: Object,
        required: true
      },
      data: {
        type: Object
      }
    },
    data: () => ({
      selectedTime: null
    }),
    computed: {
      preferredTime() {
        return preferredTime
      },
      ...mapGetters('booking', ['selectedHotel']),
      ...mapGetters('i18n', ['tc']),
      haveIcon() {
        return !!this.enhancement.icon.split('is/content')[1]
      },
      isValid() {
        return !!this.selectedTime
      },
      options() {
        const prop = this.enhancement.userInput === ENHANCEMENT_USER_INPUTS.EARLY_CHECK_IN ? 'earlyCheckIn' : 'lateCheckOut'
        return this.selectedHotel[prop]
      }
    },
    watch: {
      isValid(val) {
        this.$emit('is-valid', val)
      }
    },
    mounted() {
      if (this.data && this.data.selectedTime) {
        this.selectedTime = this.data.selectedTime
      }
    }
  }
</script>
